export default "__VITE_ASSET__DpSo6VfM__"